import { LoginState } from "../models/model";
import { LoginActions } from "../interface/reducerType";

const initialState = {
  token: "",
  loginUserDetails: {},
};
export const loginReducer = (
  state: LoginState = initialState,
  action: LoginActions
) => {
  switch (action.type) {
    case "LOGIN":
      return {
        ...state,
        token: action.payload.token,
        loginUserDetails: action.payload.loginUserDetails,
      };

    default:
      return state;
  }
};
